import React, { useState, useMemo } from 'react';
import { Input, Button, Radio } from 'antd';
import { Swiper, SwiperSlide } from 'swiper/react';
import Navigation from './header/Navigation';
import Footer from './Footer';
import '../style/invesCarriers.css';
const { Search } = Input;

// 全部数据
const source = [
    {
        pro: '三亚育才现代农业产业园',
        src: require('../assets/zdqyfb.png'),
        type: 'C_F',
        typeText: '仓库、厂房加工',
        area: 21760,
        bArea: 7200,
        av: 'C',
        status: '建设中',
        floor: '1层',
        allFloor: '1层',
        community: '龙密村',
        add: '三亚市育才生态区育才大道',
        name: '杨伟',
        phone: '15607637575'
    },
    {
        pro: '海垦立才农场公司综合楼',
        src: require('../assets/zszt_2.jpg'),
        type: 'B_G',
        typeText: '办公、商业铺面',
        area: 3600,
        bArea: 2880,
        av: 'B',
        status: '使用中',
        floor: '3层',
        allFloor: '3层',
        community: '立才居',
        com: 'C_Y',
        add: '三亚市育才生态区育才大道',
        name: '董成辉',
        phone: '17330893361'
    },
    {
        pro: '仓储用地',
        src: require('../assets/zdqyfb.png'),
        type: 'C_K',
        typeText: '物流中转、仓储',
        area: 104.68,
        bArea: 104.68,
        av: 'A',
        status: '2023年新增规划项目用地',
        floor: '无楼层',
        allFloor: '无楼层',
        community: '立才居、农场连队片区',
        com: 'Z_Z_C',
        add: '三亚市育才生态区地块编号LCCY-10-01、LCCY-11-01',
        name: '董成辉',
        phone: '17330893361'
    },
    {
        pro: '那受艺谷项目',
        src: require('../assets/zszt_4.png'),
        type: 'S_Y',
        typeText: '图书、展览等',
        area: 4500,
        bArea: 3200,
        av: 'B',
        status: '建设中',
        floor: '3层',
        allFloor: '3层',
        community: '那受村',
        com: 'H_X',
        add: '三亚市育才生态区那受村南塔小组',
        name: '彭登泽',
        phone: '15310097161'
    },
    {
        pro: '农贸市场及停车场',
        src: require('../assets/zdqyfb.png'),
        type: 'S_Y',
        typeText: '农贸市场及其商铺、停车场',
        area: 7992,
        bArea: 6393.6,
        av: 'C',
        status: '2023年土地储备计划新增项目',
        floor: '无楼层',
        allFloor: '无楼层',
        community: '龙密村',
        com: 'H_X',
        add: '三亚市育才生态区育才大道',
        name: '董成辉',
        phone: '17330893361'
    },
    {
        pro: '台亚小学',
        src: require('../assets/zszt_tyxx.jpg'),
        type: 'B_G',
        typeText: '义务教育学校',
        area: 8646.01,
        bArea: '',
        av: 'C',
        status: '已建成',
        floor: '',
        allFloor: '两层',
        community: '马脚村',
        com: 'H_X',
        add: '育才镇马脚村委会马脚村',
        name: '',
        phone: ''
    },
    {
        pro: '那受小学',
        src: require('../assets/zszt_nsxx.jpg'),
        type: 'B_G',
        typeText: '义务教育学校',
        area: 10090.21,
        bArea: '',
        av: 'C',
        status: '已建成',
        floor: '',
        allFloor: '',
        community: '那受村',
        com: 'H_X',
        add: '那受村委会旁',
        name: '',
        phone: ''
    },
    {
        pro: '那会小学',
        src: require('../assets/zszt_nhxx.jpg'),
        type: 'B_G',
        typeText: '义务教育学校',
        area: 11739.39,
        bArea: '',
        av: 'C',
        status: '已建成',
        floor: '',
        allFloor: '',
        community: '那会村',
        com: 'H_X',
        add: '育才生态区管委会以西10公里的那会村委会什盘新村',
        name: '',
        phone: ''
    }
]

function InvesCarriers() {
    // 操作数据
    const [data, setData] = useState([...source]);
    // 搜索值
    const [searchVal, setSearchVal] = useState('');
    // 类型值
    const [typeVal, setTypeVal] = useState('ALL');
    // 社区值
    const [communityVal, setCommunityVal] = useState('ALL');
    // 面积值
    const [areaVal, setAreaVal] = useState('ALL');
    // 查询功能
    const onSearch = (val) => {
        let d = []
        d = source.filter(item => item.pro.indexOf(val) >= 0);
        if (typeVal !== 'ALL') {
            d = d.filter(item => item.type === typeVal);
        }
        if (communityVal !== 'ALL') {
            d = d.filter(item => item.com === communityVal);
        }
        if (areaVal !== 'ALL') {
            d = d.filter(item => item.av === areaVal);
        }
        setData([...d]);
    };

    useMemo(() => {
        onSearch(searchVal)
    }, [typeVal, communityVal, areaVal])

    return (
        <>
            <Navigation />
            <div className="invesCarriers">
                <div className="lay-title">招商载体</div>
                <div className="invesCarriers-search">
                    <Search
                        className="invesCarriers-search__search"
                        placeholder="请输入名称"
                        allowClear
                        value={searchVal}
                        onChange={e => setSearchVal(e.target.value)}
                        onSearch={(val) => onSearch(val)}
                    />
                    <Button
                        type="primary"
                        style={{ borderRadius: 20 }}
                        onClick={() => {
                            setSearchVal('')
                            setTypeVal('ALL')
                            setCommunityVal('ALL')
                            setAreaVal('ALL')
                            setData([...source])
                        }}
                    >重置</Button>
                </div>
                <div className="invesCarriers-type">
                    类型：
                    <Radio.Group
                        defaultValue={typeVal}
                        value={typeVal}
                        onChange={e => setTypeVal(e.target.value)}
                    >
                        <Swiper
                            slidesPerView={3}
                        >
                            <SwiperSlide className="invesCarriers-type__item">
                                <Radio.Button value="ALL">不限</Radio.Button>
                            </SwiperSlide>
                            <SwiperSlide className="invesCarriers-type__item">
                                <Radio.Button value="S_Y">商业</Radio.Button>
                            </SwiperSlide>
                            <SwiperSlide className="invesCarriers-type__item">
                                <Radio.Button value="B_G">办公</Radio.Button>
                            </SwiperSlide>
                            <SwiperSlide className="invesCarriers-type__item">
                                <Radio.Button value="C_F">厂房</Radio.Button>
                            </SwiperSlide>
                            <SwiperSlide className="invesCarriers-type__item">
                                <Radio.Button value="C_K">仓库</Radio.Button>
                            </SwiperSlide>
                        </Swiper>
                    </Radio.Group>
                </div>
                <div className="invesCarriers-community">
                    社区：
                    <Radio.Group
                        defaultValue={communityVal}
                        value={communityVal}
                        onChange={e => setCommunityVal(e.target.value)}
                    >
                        <Swiper
                            slidesPerView={3}
                        >
                            <SwiperSlide className="invesCarriers-type__item">
                                <Radio.Button value="ALL">不限</Radio.Button>
                            </SwiperSlide>
                            <SwiperSlide className="invesCarriers-type__item">
                                <Radio.Button value="N_H">南海社区</Radio.Button>
                            </SwiperSlide>
                            <SwiperSlide className="invesCarriers-type__item">
                                <Radio.Button value="X_J">新建社区</Radio.Button>
                            </SwiperSlide>
                            <SwiperSlide className="invesCarriers-type__item">
                                <Radio.Button value="Z_Z_C">儋州村社区</Radio.Button>
                            </SwiperSlide>
                            <SwiperSlide className="invesCarriers-type__item">
                                <Radio.Button value="H_X">回新社区</Radio.Button>
                            </SwiperSlide>
                            <SwiperSlide className="invesCarriers-type__item">
                                <Radio.Button value="C_Y">朝阳社区</Radio.Button>
                            </SwiperSlide>
                        </Swiper>
                    </Radio.Group>
                </div>
                <div className="invesCarriers-area">
                    招商面积(㎡)：
                    <Radio.Group
                        defaultValue={areaVal}
                        value={areaVal}
                        onChange={e => setAreaVal(e.target.value)}
                    >
                        <Swiper
                            slidesPerView={3}
                        >
                            <SwiperSlide className="invesCarriers-type__item">
                                <Radio.Button value="ALL">不限</Radio.Button>
                            </SwiperSlide>
                            <SwiperSlide className="invesCarriers-type__item">
                                <Radio.Button value="A">0-2000</Radio.Button>
                            </SwiperSlide>
                            <SwiperSlide className="invesCarriers-type__item">
                                <Radio.Button value="B">2000-5000</Radio.Button>
                            </SwiperSlide>
                            <SwiperSlide className="invesCarriers-type__item">
                                <Radio.Button value="C">5000-10000</Radio.Button>
                            </SwiperSlide>
                            <SwiperSlide className="invesCarriers-type__item">
                                <Radio.Button value="D">10000-20000</Radio.Button>
                            </SwiperSlide>
                            <SwiperSlide className="invesCarriers-type__item">
                                <Radio.Button value="E">20000以上</Radio.Button>
                            </SwiperSlide>
                        </Swiper>
                    </Radio.Group>
                </div>
                <div className="invesCarriers-box">
                    {
                        data.map((item, i) => (
                            <div
                                key={i}
                                className="invesCarriers-box__item">
                                <img
                                    className="invesCarriers-box__item--img"
                                    src={item.src}
                                    alt={item.pro}
                                />
                                <p className="invesCarriers-box__item--text item-pro">{item.pro}</p>
                                <p className="invesCarriers-box__item--text">建筑面积：{item.area}㎡</p>
                                <p className="invesCarriers-box__item--text item-community">
                                    <span>招商面积：{item.bArea}㎡</span>
                                    <span className="item-status">{item.status}</span>
                                </p>
                                <p className="invesCarriers-box__item--text item-floor">
                                    <span>招商楼层：{item.floor}</span>
                                    <span>总层数：{item.allFloor}</span>
                                </p>
                                <p className="invesCarriers-box__item--text">社区：{item.community}</p>
                                <p className="invesCarriers-box__item--text">地址：{item.add}</p>
                                <p className="invesCarriers-box__item--text item-icon">
                                    <span className="item-icon-person">
                                        <span className="icon iconfont icon-rentou"></span>{item.name}
                                    </span>
                                    <span className="item-icon-phone">
                                        <span className="icon iconfont icon-dianhua"></span>{item.phone}
                                    </span>
                                </p>
                            </div>
                        ))
                    }
                    {
                        !data.length
                        &&
                        <div className="no-message">
                            <span className="icon iconfont icon-tubiao--"></span>
                            <span className="no-message__text">暂无查询楼宇！！</span>
                        </div>
                    }
                </div>
            </div>
            <Footer />
        </>
    );
}

export default InvesCarriers;